import React from "react";

const convertAssetsPath = (src, absolutePath = false) => {
  const basePath = process.env.REACT_APP_BASE_PATH || ""; // Fetch the base path
  return `${absolutePath ? "" : basePath}${src}`;
};

const Assets = ({ src, alt = "img", absolutePath = false, fallbackSrc = '../../../public/images/upload.png', ...props }) => {
  return (
    <img
      {...props}
      src={src}
      alt={alt}
      // onError={(e) => {
      //   e.target.onerror = null; // Prevent infinite loop if fallback also fails
      //   e.target.src = fallbackSrc;
      // }}
    />
  );
};

export default Assets;

